import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function DropdownListItem({
  children,
  className,
  hardSides,
  hardTop,
  ignoreToggle,
  removeBorderTop,
  role,
  ...props
}) {
  const classes = classNames(
    {
      "hard--sides": hardSides,
      "hard--top": hardTop,
      "no-border": removeBorderTop,
      "oui-dropdown__item": true,
      "oui-dropdown__item--separator axiom-typography--xs soft--ends soft-double--sides": role === "separator"
    },
    className
  );
  const handleClick = (event) => {
    if (role === "separator") {
      event.preventDefault();
      event.stopPropagation();
    } else if (ignoreToggle) {
      event.ignoreToggle = true;
      event.persist();
    }
  };
  return /* @__PURE__ */ jsx("li", { className: classes, onClick: handleClick, role, ...props, children });
}
DropdownListItem.propTypes = {
  /** Nodes to display within */
  children: PropTypes.node,
  /** CSS class names. */
  className: PropTypes.string,
  /** Remove padding from sides */
  hardSides: PropTypes.bool,
  /** Remove padding from top */
  hardTop: PropTypes.bool,
  /** Instructs the Dropdown parent to ignore clicks for toggle purposes. */
  ignoreToggle: PropTypes.bool,
  /** Removes border if true */
  removeBorderTop: PropTypes.bool,
  /**
   * Aria role for this list item. See roles here:
   * https://www.w3.org/WAI/PF/aria/roles
   */
  role: PropTypes.string
};

export { DropdownListItem as default };
